<template>
  <div>
    <app-head></app-head>
    <app-body>
      <div>
        <div class="about-us-background">
          <div class="banner-content">
            <div class="banner-content-white-text">
              <h1 style="font-family: STCaiyun, Arial, sans-serif;">关于我们</h1>
              <hr>
              <p>
                西安伟思特声学科技有限公司成立于2022年11月28日，是一家专注于声学技术研发与应用的高科技企业。我们致力于通过先进的声学技术，为客户提供专业的声学解决方案，涵盖声学产品开发、声学工程设计、噪声与振动控制等多个领域。</p>
              <div class="breadcrumb-container">
                <el-breadcrumb separator="/">
                  <el-breadcrumb-item>
                    <router-link to="/"><i class="el-icon-house"></i> 首页</router-link>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>关于我们</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
          </div>
        </div>
        <div class="about-us-container">
          <div class="about-us-content" :class="{ 'animated': isAnimated }">
            <h1>关于我们</h1>
            <p>
              西安伟思特声学科技有限公司成立于2022年11月28日，是一家专注于声学技术研发与应用的高科技企业。
              我们致力于通过先进的声学技术，为客户提供专业的声学解决方案，涵盖声学产品开发、声学工程设计、噪声与振动控制等多个领域。</p>
            <h3>我们的使命与愿景</h3>
            <Strong>使命：</Strong>
            通过创新的声学技术，为客户创造更安静、更舒适、更高效的生活与工作环境。<br>
            <Strong>愿景：</Strong>
            成为声学领域的领先者，推动声学技术在各个行业的广泛应用，助力社会的可持续发展。
            <h3>我们的服务</h3>
            <Strong>声学产品开发：</Strong>
            我们的团队将为您提供专业的声学产品开发服务，包括声学产品的设计、制造、测试等。<br>
            <Strong>声学工程设计：</Strong>
            我们的团队将为您提供专业的声学工程设计服务，包括声学工程设计的咨询、设计、实施等。<br>
            <Strong>噪声与振动控制：</Strong>
            我们的团队将为您提供专业的噪声与振动控制服务，包括噪声控制、振动控制等。<br>
          </div>
          <div class="about-us-pic" :class="{ 'animated': isAnimated }">
            <el-carousel autoplay height="450px">
              <el-carousel-item v-for="item in carouselImages" :key="item.id">
                <img :src="item.url" :alt="item.alt" style="width: 100%; height: 100%; object-fit: cover;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <hr>
        <div class="about-us-attitude">
          <div class="about-us-attitude-pic" :class="{ 'animated': isAnimated }">
            <el-carousel autoplay height="450px">
              <el-carousel-item v-for="item in carouselImages1" :key="item.id">
                <img :src="item.url" :alt="item.alt" style="width: 100%; height: 100%; object-fit: cover;">
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="about-us-attitude-title" :class="{ 'animated': isAnimated }">
            <h1>我们的价值观</h1>
            <h3>我们的价值观是</h3>
            <strong><span>客户至上&emsp;创新驱动&emsp;团队合作&emsp;诚实守信</span></strong><br>
            <p>客户至上：&nbsp;我们始终将客户需求放在首位，致力于为客户提供高质量的产品和服务，帮助客户实现价值最大化。</p>
            <p>创新驱动：&nbsp;我们坚信创新是企业发展的核心动力，不断投入研发资源，推动声学技术的创新与突破。</p>
            <p>团队合作：&nbsp;注重团队协作，充分发挥团队成员的专业优势，共同攻克技术难题，实现企业目标。</p>
            <p>诚信经营：&nbsp;我们坚守诚信原则，遵守法律法规，以诚信赢得客户的信任与支持。</p>
          </div>
        </div>
        <hr>
        <div class="about-us-attitude">
          <div class="about-us-attitude-title" :class="{ 'animated': isAnimated }">
            <h1>员工风采</h1>
            <h3>团队的力量</h3>
            <p>在每一次的挑战面前，我们团队总是能够展现出无与伦比的凝聚力和创造力。
              我们相信，团队的力量不仅仅来自于个体的优秀，更来自于我们共同的目标和不懈的努力。</p>
            <h3>合作与共赢</h3>
            <p>我们珍视每一次合作的机会，无论是内部的协作还是与外部伙伴的合作。我们相信，通过开放的沟通和真诚的合作，我们能够实现共赢，共同成长。</p>
            <h3>感恩与分享</h3>
            <p>我们感谢每一位员工的辛勤工作和无私奉献。我们相信，通过分享成功和经验，我们能够激发更多的潜力，创造更多的价值。</p>
            <h3>未来展望</h3>
            <p>展望未来，我们充满信心。我们将继续携手并进，共同迎接新的挑战，创造更多的辉煌。让我们以满腔的热情和坚定的信念，迎接每一个新的明天。</p>
          </div>
          <div class="about-us-attitude-pic" :class="{ 'animated': isAnimated }">
            <el-carousel autoplay height="500px">
              <el-carousel-item v-for="item in carouselImages2" :key="item.id">
                <img :src="item.url" :alt="item.alt" style="width: 100%; height: 100%; object-fit: cover;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <hr>
        <div class="about-us-else" :class="{ 'animated': isAnimated }">
          <div class="about-us-dominance">
            <div class="about-us-dominance-title">
              <h1>技术优势</h1>
              <Strong>定制化能力：</Strong>
              提供从诊断、设计到设备交付的全流程服务。<br>
              <Strong>新能源配套服务：</Strong>
              新能源汽车测试设备、声学性能优化。<br>
              <Strong>绿色标准：</Strong>
              解决方案符合ISO 3745等国际噪声控制规范。<br>
            </div>
            <img src="@/assets/img/customizable.png" style="width: 50%" alt="About us" class="img-fluid"/>
          </div>
          <div class="about-us-positioning" >
            <div class="about-us-positioning-title">
              <h1>行业属性及定位</h1>
              <Strong>所属行业：</Strong>
              科学研究和技术服务业（细分领域：研究和试验发展）。<br>
              <Strong>业务特点：</Strong>
              结合声学技术、高端仪器制造与软件开发，服务领域涵盖工业减振、新能源汽车测试等前沿场景。<br>
            </div>
            <img src="@/assets/img/target.jpg" style="width: 55%" alt="About us" class="img-fluid"/>
          </div>
        </div>
      </div>
    </app-body>
    <app-foot></app-foot>
  </div>
</template>

<script>
import AppHead from '../common/AppHeader.vue';
import AppBody from '../common/AppPageBody.vue'
import AppFoot from '../common/AppFoot.vue'

export default {
  name: "index",
  components: {
    AppHead,
    AppBody,
    AppFoot
  },
  data() {
    return {
      hue: 90,
      hue1: 90,
      animationFrameId: null,
      carouselImages: [
        {id: 1, url: require('@/assets/img/about-img-1.jpg'), alt: '第一张图片'},
        {id: 2, url: require('@/assets/img/about-img-2.jpg'), alt: '第二张图片'}
      ],
      carouselImages1: [
        {id: 1, url: require('@/assets/img/values-1.jpg'), alt: '第一张图片'},
        {id: 2, url: require('@/assets/img/values-2.jpg'), alt: '第二张图片'},
        {id: 3, url: require('@/assets/img/values-3.jpg'), alt: '第三张图片'},
        {id: 4, url: require('@/assets/img/values-4.jpg'), alt: '第四张图片'},
      ],
      carouselImages2: [
        {id: 1, url: require('@/assets/about-us/p1.jpg'), alt: '第一张图片'},
        {id: 2, url: require('@/assets/about-us/p2.jpg'), alt: '第二张图片'},
        {id: 3, url: require('@/assets/about-us/p3.jpg'), alt: '第三张图片'},
        {id: 4, url: require('@/assets/about-us/p4.jpg'), alt: '第四张图片'},
        {id: 4, url: require('@/assets/about-us/p5.jpg'), alt: '第五张图片'},
      ],
      // 控制动画是否触发的标志
      isAnimated: false,
    };
  },
  created() {

  },
  mounted() {
    // 在组件挂载后，延迟一小段时间触发动画，确保页面渲染完成
    setTimeout(() => {
      this.isAnimated = true;
      this.$(document).ready(() => {
        // 页面加载后自动执行淡入动画
        this.$("#div5").fadeToggle("slow");
      });
    }, 100);
  },
  watch: {},
  methods: {}
}
</script>

<style scoped>

.about-us-background {
  width: 100%;
  background-image: url("../../../assets/img/contact-bg.jpg");
  margin-top: -30px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 500px
}

.banner-content-white-text {
  position: absolute;
  top: 40%;
  left: 50%;
  color: white;
  transform: translate(-50%, -50%);
  text-align: center;
}

/* 面包屑容器样式 */
.breadcrumb-container {
  position: absolute;
  left: 50%;
  margin-top: 175px;
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(255, 255, 255, 0.5); /* 半透明背景 */
  padding: 8px 16px;
  border-radius: 4px;
}

.about-us-else {
  margin: 0 auto;
  display: flex;
  width: 90%;
  /* 允许子元素换行 */
  flex-wrap: wrap;
  /* 子元素之间无间距 */
  gap: 0;
  transform: translateY(600%);
  transition: transform 1.5s ease;
}

.about-us-positioning {
  margin: 100px 0 100px auto;
  width: 50%;
  display: flex;
  /* 允许子元素换行 */
  flex-wrap: wrap;
  /* 子元素之间无间距 */
  gap: 0;
}

.about-us-positioning-title {
  width: calc(50% - 50px);
  padding-bottom: 100px;
}

.about-us-dominance {
  margin: 100px 0 100px 0;
  width: 50%;
  display: flex;
  /* 允许子元素换行 */
  flex-wrap: wrap;
  /* 子元素之间无间距 */
  gap: 0;
}

.about-us-dominance-title {
  width: calc(50% - 50px);
  padding-bottom: 100px;
}

.about-us-attitude-pic {
  /* 调整宽度，减去一半的间距 */
  width: calc(55%);
  padding-bottom: 100px;
  opacity: 0;
  transition: opacity 3s ease;
  &.animated {
    display: block;
    opacity: 1;
  }
}

.about-us-attitude {
  margin: 100px auto 0;
  width: 87%;
  display: flex;
  /* 允许子元素换行 */
  flex-wrap: wrap;
  /* 子元素之间无间距 */
  gap: 50px;
}

.about-us-attitude-title {
  width: calc(45% - 50px);
  padding-bottom: 100px;
  opacity: 0;
  transition: opacity 3s ease;
  &.animated {
    display: block;
    opacity: 1;
  }
}

.about-us-container {
  margin: 100px auto 0;
  width: 87%;
  /* 使用 Flex 布局 */
  display: flex;
  /* 允许子元素换行 */
  flex-wrap: wrap;
  /* 子元素之间无间距 */
  gap: 50px;
}

.about-us-content {
  padding-bottom: 100px;
  width: calc(50% - 40px);
  transform: translateX(-100%);
  transition: transform 0.8s ease;
}

.about-us-pic {
  transform: translateX(100%);
  /* 调整宽度，减去一半的间距 */
  width: calc(50% - 10px);
  padding-bottom: 100px;
  transition: transform 0.8s ease;
}

.animated {
  /* 动画结束状态，回到原始位置 */
  transform: translateX(0);
}

.banner-content-white-text h1 {
  font-size: 36px;
  margin-bottom: 20px;
}
</style>